import { ABSENCE_TYPES, AbsenceType } from '@app/shared/types/enums/absence-type';

/**
 * Absence types accepted by POST/PUT Absence endpoints (`AbsenceTypeEnum` on the backend).
 * The current backend write set is the full {@link AbsenceType} enum, including Vacation.
 */
export const WRITABLE_ABSENCE_TYPES = ABSENCE_TYPES;

export type WritableAbsenceType = AbsenceType;

const WRITABLE_ABSENCE_TYPE_SET: ReadonlySet<string> = new Set(WRITABLE_ABSENCE_TYPES);

export function isWritableAbsenceType(value: string): value is WritableAbsenceType {
  return WRITABLE_ABSENCE_TYPE_SET.has(value);
}
